import { render, staticRenderFns } from "./WasteDriveTo.vue?vue&type=template&id=4d90821d&"
import script from "./WasteDriveTo.vue?vue&type=script&lang=js&"
export * from "./WasteDriveTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports